import LazyLoad from 'vanilla-lazyload'
import '../util/smoothscroll'

export default (() => {

  new LazyLoad({
    elements_selector: '.lazy',
  })
})();


// WEBPACK FOOTER //
// ./scripts/layout/common.js